import { Modal } from "../ui/components/Modal";
import api from "../api";

export class MoveModal extends Modal {
    init() {
        super.init();
        this.includeComponents({
            toast: "document@#toast",
            createFolder: "document@#CreateFolderModal",
        });

        this.currentFileId = null;
        this.confirmDialog = null;
        this.isCreatingFolder = false;
        this.CreateAndMoveBtn.disable()

        this.dropdownToggle?.on("click", (e) => {
            e.stopPropagation();
            this.toggleDropdown();
        });

        this.dropdownMenu?.on("click", (e) => {
            const folderItem = e.target.closest(".js-folder-item");
            if (!folderItem) return;

            const isCreate = folderItem.dataset.value === "create";

            this.selectFolder(folderItem.dataset.value, folderItem.textContent);

            isCreate? this.showCreateFolderInput() : this.hideCreateFolderInput();
            this.dropdownMenu?.removeClass("show");
        });

        this.input?.on("input", () => {
            this.validateInput();
        });

        this.confirmBtn?.on("click", () => this.handleMove());
        this.CreateAndMoveBtn?.on("click", () => this.handleMove());
    }

    showCreateFolderInput() {
        this.isCreatingFolder = true;
        this.addClass("creating-folder");
    }

    hideCreateFolderInput() {
        this.isCreatingFolder = false;
        this.removeClass("creating-folder");
    }

     toggleDropdown() {
        if (this.dropdownMenu?.hasClass("show")) {
            this.dropdownMenu.removeClass("show")
        } else {
            this.dropdownMenu.addClass("show");
        }
    }

    validateInput() {
        if (this.isCreatingFolder) {
            const folderName = this.input.element.value.trim();
            if (folderName) {
                this.CreateAndMoveBtn.enable();
            } else {
                this.CreateAndMoveBtn.disable();
            }
        }
    }

    setConfirmDialog(dialog) {
        this.confirmDialog = dialog;
    }

    async open(fileId, bulk) {
        this.currentFileId = bulk ? fileId : [fileId];
        this.isCreatingFolder = false;

        if (this.selectedFolder) {
            this.selectedFolder.element.dataset.value = "";
        }

        if (this.confirmBtn) this.confirmBtn.disabled = true;

        this.hideCreateFolderInput();

        try {
            const folders = await api.get("/api/folders");
            this.setFolders(folders);
        } catch (error) {
            console.error("Error loading folders:", error);
        }

        super.show();
    }

    setFolders(folders) {
        this.folder_items.element.innerHTML = folders
            .map((folder) => {
                const escapedName = folder.name
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#39;");

                return `
                    <div class="dropdown-item js-folder-item" 
                         data-value="${folder.id}" 
                         data-fullname="${escapedName}" 
                         title="${escapedName}">
                        ${folder.name}
                    </div>
                `;
            })
            .join("");
    }

    selectFolder(id, name) {
        if (this.selectedFolder) {
            this.selectedFolder.element.textContent = name;
            this.selectedFolder.element.dataset.value = id;
            this.selectedFolder.element.title = name;
        }
        localStorage.setItem("folder_name", name);

        if (this.confirmBtn) this.confirmBtn.disabled = false;
    }

    async handleMove() {
        try {
            let folderId;

            if (this.isCreatingFolder) {
                const folderName = this.input.element.value.trim();
                if (!folderName) return;

                localStorage.setItem("folder_name", folderName);

                const newFolder = await api.post("/api/folders", {
                    name: folderName,
                });
                folderId = newFolder.id;
            } else {
                folderId = this.selectedFolder?.element.dataset.value;

                if (!folderId) return;
            }

            await api.post(`/api/folders/${folderId}/assign`, {
                ids: this.currentFileId,
            });

            this.hide();
            localStorage.setItem("toastMessage", "move");
            window.location.reload();
        } catch (error) {
            console.error("Move error:", error);
        }
    }
}
